export default __webpack_public_path__ + "static/1078-16adec19885010c424c7c8bbf5d6a834.gif";